var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.subject == 1 ||
    _vm.subject == 2 ||
    _vm.subject == 3 ||
    _vm.subject == 4 ||
    _vm.subject == 5 ||
    _vm.subject == 6
      ? 'course' + _vm.subject
      : 'course',
    _vm.isNoviceClass ? 'novice_class' : '',
    'compose' ]},[_c('div',{staticClass:"header"},[_c('span',{staticClass:"cursor",on:{"click":_vm.go_class}}),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.composeLessInfo.title))])]),_vm._v(" "),_c('compose-list',{attrs:{"subType":_vm.subType}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c273686","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bussiness/courseCompose/courseCompose.vue
// module id = null
// module chunks = 